<template>
  <a-menu
      v-model:openKeys="openKeys"
      v-model:selectedKeys="selectedKeys"
      :mode="viewMode"
      theme="dark"
      :inline-collapsed="collapsed"
    >
      <a-sub-menu key="/user" >
        <template #icon>
          <UserOutlined />
        </template>
        <template #title>用户管理</template>
        <a-menu-item key="/home/user">
          <template #icon>
            <UserOutlined /> 
          </template>
          <router-link :to="{ path: '/home/user'}">
            用户列表
          </router-link>
        </a-menu-item>
        <a-menu-item key="/home/user/auth">
          <template #icon>
            <IdcardOutlined />
          </template>
          <router-link :to="{ path: '/home/user/auth'}">
            登录凭证
          </router-link>
        </a-menu-item>
        <a-menu-item key="/home/vips"  >
          <template #icon>
            <QqOutlined />
          </template>
          <router-link :to="{ path: '/home/vips'}"  >
            VIP管理
          </router-link>
        </a-menu-item>
        <a-menu-item key="/home/vips/create"  v-if="[1, 2].indexOf(user_role) > -1 || ['develop', 'production'].indexOf(department) > -1 "  >
          <template #icon>
            <QqOutlined />
          </template>
          <router-link :to="{ path: '/home/vips/create'}"  >
            开通 VIP
          </router-link>
        </a-menu-item>
         <a-menu-item key="/home/user/profile"  >
          <template #icon>
            <AuditOutlined />
          </template>
          <router-link :to="{ path: '/home/user/profile'}"  >
            Profile
          </router-link>
        </a-menu-item>
      </a-sub-menu>
     
      <a-sub-menu key="/ueg" >
        <template #icon>
          <StopOutlined />
        </template>
        <template #title>UEG</template>
        <a-menu-item key="/home/user/ban_manage"  v-if="[1, 2].indexOf(user_role) > -1 || ['develop', 'production'].indexOf(department) > -1 "  >
          <template #icon>
            <StopOutlined />
          </template>
          <router-link :to="{ path: '/home/user/ban_manage'}">
            封禁管理
          </router-link>
        </a-menu-item>
        <a-menu-item key="/home/anti/sensiword">
          <template #icon>
            <BugOutlined />
          </template>
          <router-link :to="{ path: '/home/anti/sensiword'}">
            敏感词管理
          </router-link>
        </a-menu-item>
        <a-menu-item key="/home/device/search">
          <template #icon>
            <MobileOutlined />
          </template>
          <router-link :to="{ path: '/home/device/search'}">
            设备管理
          </router-link>
        </a-menu-item>
      </a-sub-menu>
      <a-sub-menu key="/community/article"  >
        <template #icon>
          <ContainerOutlined />
        </template>
        <template #title>社区</template>
        <a-menu-item key="/home/community/article">
          <template #icon>
            <ContainerOutlined />
          </template>
          <router-link :to="{ path: '/home/community/article'}">
            主贴管理
          </router-link>
        </a-menu-item>
        <a-menu-item key="/home/community/comment">
          <template #icon>
            <ContainerOutlined />
          </template>
          <router-link :to="{ path: '/home/community/comment'}">
            评论管理
          </router-link>
        </a-menu-item>
        <a-menu-item key="/home/community/post-config">
          <template #icon>
            <ContainerOutlined />
          </template>
          <router-link :to="{ path: '/home/community/post-config'}">
            帖子模板配置
          </router-link>
        </a-menu-item>
       
      </a-sub-menu>
      <a-sub-menu key="/product-operator" >
        <template #icon>
          <LikeOutlined />
        </template>
        <template #title>产品运营</template>
        
        <a-menu-item key="/home/creation/works"   v-if="[1, 2].indexOf(user_role) > -1 || ['develop', 'production'].indexOf(department) > -1 " >
          <template #icon>
            <FileImageOutlined />
          </template>
          <router-link :to="{ path: '/home/creation/works'}">
            作品列表
          </router-link>
        </a-menu-item>
         <a-menu-item key="/home/creation/works/review" v-if="[1].indexOf(user_role) > -1 ">
          <template #icon>
            <FileImageOutlined />
          </template>
          <router-link :to="{ path: '/home/creation/works/review'}">
            作品审查
          </router-link>
        </a-menu-item>
        <a-menu-item key="/home/creation/tabs">
          <template #icon>
            <FileImageOutlined /> 
          </template>
          <router-link :to="{ path: '/home/creation/tabs'}">
            模板Tab
          </router-link>
        </a-menu-item>
        <a-menu-item key="/home/creation/options">
          <template #icon>
            <FileImageOutlined /> 
          </template>
          <router-link :to="{ path: '/home/creation/options'}">
            模板配置
          </router-link>
        </a-menu-item>
        <a-menu-item key="/home/creation/batch-create">
          <template #icon>
            <FileImageOutlined /> 
          </template>
          <router-link :to="{ path: '/home/creation/batch-create'}">
            批量创建模板
          </router-link>
        </a-menu-item>
        <a-menu-item key="/home/template_scene">
          <template #icon>
            <FileImageOutlined /> 
          </template>
          <router-link :to="{ path: '/home/template_scene'}">
            模板场景管理
          </router-link>
        </a-menu-item>
        <a-menu-item key="/home/op_slots">
          <template #icon>
            <FileImageOutlined /> 
          </template>
          <router-link :to="{ path: '/home/op_slots'}">
            运营位管理
          </router-link>
        </a-menu-item>
        <a-menu-item key="/home/home_banner">
          <template #icon>
            <FileImageOutlined /> 
          </template>
          <router-link :to="{ path: '/home/home_banner'}">
            首页 Banner
          </router-link>
        </a-menu-item>
          <a-menu-item key="/home/popup">
          <template #icon>
            <FileImageOutlined /> 
          </template>
          <router-link :to="{ path: '/home/popup'}">
            首页弹窗
          </router-link>
        </a-menu-item>
        <!-- <a-menu-item key="/home/creation/sskills">
          <template #icon>
            <FireOutlined />
          </template>
          <router-link :to="{ path: '/home/creation/sskills'}">
          创意社区
          </router-link>
        </a-menu-item> -->
        <a-menu-item key="/home/i18n/text">
          <template #icon>
            <GlobalOutlined />
          </template>
          <router-link :to="{ path: '/home/i18n/text'}">
            国际化文案
          </router-link>
        </a-menu-item>
         <a-menu-item key="/home/creation/style">
          <template #icon>
            <FileImageOutlined />
          </template>
          <router-link :to="{ path: '/home/creation/style'}">
            创作类型说明
          </router-link>
        </a-menu-item>
      </a-sub-menu>
      <a-sub-menu key="/home/order">
        <template #icon>
         <PieChartOutlined />
        </template>
        <template #title>订单管理</template>
        <a-menu-item key="/home/order/search" >
          <template #icon>
            <LineChartOutlined />
          </template>
          <router-link :to="{ path: '/home/order/search'}"  >
            订单管理
          </router-link>
        </a-menu-item>
        <a-menu-item key="/home/order/tools">
          <template #icon>
            <ToolOutlined />
          </template>
          <router-link :to="{ path: '/home/order/tools'}">
            订单工具
          </router-link>
        </a-menu-item>
      </a-sub-menu>
      <a-sub-menu key="/testcase" >
        <template #icon>
          <ContainerOutlined />
        </template>
        <template #title>算法测试</template>
        <a-menu-item key="/home/testcase/cases">
          <template #icon>
            <BarsOutlined />
          </template>
          <router-link :to="{ path: '/home/testcase/cases'}">
            测试用例
          </router-link>
        </a-menu-item>
        <a-menu-item key="/home/testcase/batchs">
          <template #icon>
            <BoldOutlined />
          </template>
          <router-link :to="{ path: '/home/testcase/batchs'}">
            测试批次
          </router-link>
        </a-menu-item>
        <a-menu-item key="/home/testcase/packages">
          <template #icon>
            <DatabaseOutlined />
          </template>
          <router-link :to="{ path: '/home/testcase/packages'}">
            素材包  
          </router-link>
        </a-menu-item>


        <a-menu-item key="/home/testcase/labels">
          <template #icon>
            <FlagOutlined />
          </template>
          <router-link :to="{ path: '/home/testcase/labels'}">
            打标管理
          </router-link>
        </a-menu-item>
      
      </a-sub-menu>
      <a-sub-menu key="/home/stats" v-if="[1,2].indexOf(user_role) > -1">
        <template #icon>
          <PieChartOutlined /> 
        </template>
        <template #title>数据统计</template>
        <a-menu-item key="/href/metabase">
        <template #icon>
          <LinkOutlined />
        </template>
        <a href="http://metabase.in.xuantu.pro/" target="blank">Metabase</a>
      </a-menu-item>
        <a-menu-item key="/home/stats/new_user_regions" >
          <template #icon>
           <PieChartOutlined /> 
          </template>
          <router-link :to="{ path: '/home/stats/new_user_regions'}">
            用户数量
          </router-link>
        </a-menu-item>
        <a-menu-item key="/home/stats/new_user_counts">
          <template #icon>
           <PieChartOutlined /> 
          </template>
          <router-link :to="{ path: '/home/stats/new_user_counts'}">
            新增用户
          </router-link>
        </a-menu-item>
       
        <a-menu-item key="/home/stats/total"   >
          <template #icon>
            <PieChartOutlined /> 
          </template>
          <router-link :to="{ path: '/home/stats/total'}">
            整体数据
          </router-link>
        </a-menu-item>
        <a-menu-item key="/home/stats/yesterday"  >
          <template #icon>
            <PieChartOutlined /> 
          </template>
          <router-link :to="{ path: '/home/stats/yesterday'}">
            昨日数据
          </router-link>
        </a-menu-item>
        <a-menu-item key="/home/stats/payment" >
          <template #icon>
            <DollarOutlined />
          </template>
          <router-link :to="{ path: '/home/stats/payment'}">
            付费率统计
          </router-link>
        </a-menu-item>
        <a-menu-item key="/home/creation/stats/style">
          <template #icon>
           <PieChartOutlined /> 
          </template>
          <router-link :to="{ path: '/home/creation/stats/style'}">
            创作统计
          </router-link>
        </a-menu-item>
        <a-menu-item key="/home/stats/generation"  >
          <template #icon>
            <PieChartOutlined /> 
          </template>
          <router-link :to="{ path: '/home/stats/generation'}">
            昨日创作数据
          </router-link>
        </a-menu-item>
      </a-sub-menu>
      <a-sub-menu key="/xae"  v-if="[1, 2].indexOf(user_role) > -1 || ['develop', 'production'].indexOf(department) > -1 "  >
        <template #icon>
          <GoldOutlined />
        </template>
        <template #title>XAE</template>
        <a-menu-item key="/xae/queue/executors">
          <template #icon>
            <LayoutOutlined />
          </template>
            <router-link :to="{ path: '/xae/queue/executors'}">
              队列配置
            </router-link>
        </a-menu-item>
        <!-- <a-menu-item key="/xae/queue/multi">
          <template #icon>
            <BarsOutlined />
          </template>
            <router-link :to="{ path: '/xae/queue/multi'}">
              多队列配置
            </router-link>
        </a-menu-item> -->
        <a-menu-item key="/queue/status">
          <template #icon>
            <BarChartOutlined />
            </template>
            <router-link :to="{ path: '/xae/queue/status'}">
              队列监控
            </router-link>
        </a-menu-item>
      </a-sub-menu>
      <a-sub-menu key="/tools">
        <template #icon>
          <ToolOutlined />
        </template>
        <template #title>工具列表</template>
        <a-menu-item key="/home/creation/tools">
          <template #icon>
            <ToolOutlined />
          </template>
          <router-link :to="{ path: '/home/creation/tools'}">
            创作工具
          </router-link>
        </a-menu-item>
        <a-menu-item key="/home/creation/operation_tool">
          <template #icon>
            <ToolOutlined />
          </template>
          <router-link :to="{ path: '/home/creation/operation_tool'}">
            线上运营离职
          </router-link>
        </a-menu-item>
      </a-sub-menu>
       <a-menu-item key="/home/sys/common_config"  v-if="[1, 2].indexOf(user_role) > -1 || ['develop', 'production'].indexOf(department) > -1 "  >
        <template #icon>
          <PieChartOutlined /> 
        </template>
        <router-link :to="{ path: '/home/sys/common_config'}">
          系统配置
        </router-link>
      </a-menu-item>
      <!-- <a-menu-item key="/href/autodl">
        <template #icon>
          <LinkOutlined />
        </template>
        <a href="https://www.autodl.com/console/instance/list" target="blank">AutoDL 控制台</a>
      </a-menu-item> -->
      <a-menu-item key="/href/autodl">
        <template #icon>
          <LinkOutlined />
        </template>
        <a href="https://console.tus-tech.com/uphost/uphost" target="blank">启迪(uphost) 控制台</a>
      </a-menu-item>
      <a-menu-item key="/href/ksyun">
        <template #icon>
          <LinkOutlined />
        </template>
        <a href="https://kenc.console.ksyun.com/#/cloud/instance?namespaceId=1006" target="blank">金山云 控制台</a>
      </a-menu-item>  
      <a-menu-item key="/href/ksyun">
        <template #icon>
          <LinkOutlined />
        </template>
        <a href="https://ecs.console.aliyun.com/server/region/cn-shanghai" target="blank">阿里云 控制台</a>
      </a-menu-item>
    </a-menu>
</template>
<script >
import { defineComponent, reactive, toRefs, watch } from 'vue';
import { useRouter, useRoute } from 'vue-router'
import {useStore} from 'vuex'

import {
  PieChartOutlined,
  IdcardOutlined,
  UserOutlined,
  FileImageOutlined,
  LineChartOutlined,
  GoldOutlined,
  QqOutlined,DollarOutlined,
  LinkOutlined,MobileOutlined,BarChartOutlined,
  // FireOutlined,
  StopOutlined,LikeOutlined,BugOutlined,
  GlobalOutlined,
  LayoutOutlined,
  BarsOutlined,
  FlagOutlined,DatabaseOutlined,
  AuditOutlined,ContainerOutlined,BoldOutlined,
  ToolOutlined
} from '@ant-design/icons-vue';


export default defineComponent({
  components: {
    PieChartOutlined,
    LineChartOutlined,
    UserOutlined,    
    IdcardOutlined,
    GoldOutlined,
    FileImageOutlined,
    FlagOutlined,
    BarsOutlined,
    QqOutlined,
    DatabaseOutlined,
    // FireOutlined,
    StopOutlined,
    LikeOutlined,
    BugOutlined,
    LinkOutlined,
    MobileOutlined,
    BarChartOutlined,
    DollarOutlined,
    GlobalOutlined,
    LayoutOutlined,
    AuditOutlined,ContainerOutlined,BoldOutlined,
    ToolOutlined
  },
  computed:{
    user_id: () => {
      const store = useStore()
      if (store) {
        return store.state.user.user_id
      }
    },
    department: () => {
      const store = useStore()
      if (store) {
        return store.state.user.department
      }
    },
    user_role : () => {
      const store = useStore()
      if (store) {
        return store.state.user.user_role
      }
    }, 
  },
  data() {
    return {
      viewMode: "inline",
    }
  },
  mounted: function(){
    this.viewMode = "inline"
    // 如果显示宽度小于 700 ，则水平展示
    if (window.innerWidth < 700) {
      this.viewMode = "horizontal"
    }
  },
  watch: {
    $route: {
       handler(route,oldval){
        this.selectedKeys = [route.path]
      },
      // 深度观察监听
      deep: true
    }
  },
  setup() {
    let route = useRoute()
    const state = reactive({
      collapsed: false,
      selectedKeys: [route.path],
      openKeys: [route.meta.key],
      preOpenKeys: ['basic'],
    });

    watch(
      () => state.openKeys,
      (val, oldVal) => {
        state.preOpenKeys = oldVal;
      },
    );
    const router = useRouter()
    watch (
        () => state.selectedKeys,
        (val, oldVal) => {
            state.selectedKeys = val
            
        }
    )
    const toggleCollapsed = () => {
      state.collapsed = !state.collapsed;
      state.openKeys = state.collapsed ? [] : state.preOpenKeys;
    };

    return {
      ...toRefs(state),
      toggleCollapsed,
    };
  },
});
</script>
